import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackCTA } from "@/lib/analytics";
import BookCallButton from "@/components/BookCallButton";

export default function CTASection({
  heading = "Need help preparing your next Tier II report?",
  sub = "Send us your facility and chemical information — we'll review it and follow up. No obligation.",
  location = "cta-section",
}) {
  return (
    <section className="relative overflow-hidden bg-navy-900 noise-overlay" data-testid="cta-section">
      <div className="absolute inset-0 grid-pattern opacity-60" aria-hidden="true" />
      <div className="relative mx-auto max-w-5xl px-5 lg:px-8 py-16 lg:py-20 text-center">
        <h2 className="font-heading text-3xl lg:text-4xl font-bold tracking-tight text-white">{heading}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-slate-300 leading-relaxed">{sub}</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/free-tier-ii-assessment"
            onClick={() => trackCTA("Free Assessment", location)}
            className="inline-flex items-center gap-2 rounded-md bg-amber-500 px-7 py-3.5 text-base font-bold text-navy-900 transition-transform hover:-translate-y-0.5 hover:bg-amber-400"
            data-testid="cta-primary-assessment"
          >
            Get a Free Tier II Assessment
            <ArrowRight className="h-5 w-5" aria-hidden="true" />
          </Link>
          <BookCallButton location={location} size="md" />
        </div>
      </div>
    </section>
  );
}
